import { connect } from "@formily/react";
import { Button as AntButton } from "antd";
import { theme } from "antd";
import type { GlobalToken } from "antd/es/theme/interface";
import { createStyles } from "antd-style";
import { twMerge } from "tailwind-merge";

// Define a type that accesses theme tokens safely
type TokenWithGradient = GlobalToken & {
  Button?: {
    primaryType?: string;
    primaryGradient?: string;
  };
};

// Create a styles function that accepts token as a parameter
const useStyle = createStyles(({ prefixCls, css, token }) => {
  const customToken = token as TokenWithGradient;
  const buttonToken = customToken.Button || { primaryGradient: false };

  return {
    gradientButton: css`
      &.${prefixCls}-btn-primary:not([disabled]):not(
          .${prefixCls}-btn-dangerous
        ):not(.bg-green-500) {
        background: ${token.colorPrimary};
        color: ${token.colorTextLightSolid};
        position: relative;
        z-index: 1;

        &::before {
          content: "";
          background: linear-gradient(
            ${
              buttonToken.primaryGradient ||
              `90deg, ${token.colorPrimary}, ${token.colorPrimaryBg}`
            }
          );
          position: absolute;
          inset: -1px;
          opacity: 1;
          transition: all ${token.motionDurationMid};
          border-radius: inherit;
          z-index: -1;
        }

        &:hover::before {
          opacity: 0;
        }
      }
    `,
  };
});

export const Button = connect((props) => {
  const { token } = theme.useToken();
  const customToken = token as TokenWithGradient;
  const { className, type, ...restProps } = props;

  if (type === "primary" && customToken.Button?.primaryType === "gradient") {
    const object = useStyle({ token });
    const styles = object.styles;

    const classNames = twMerge(className || "", styles.gradientButton);
    return <AntButton type={type} className={classNames} {...restProps} />;
  }

  return <AntButton type={type} className={className} {...restProps} />;
});
